var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"unsubscribe-page"},[_c('img',{staticClass:"qrcode_page_img",attrs:{"src":require("../../assets/unsubscribe.jpg")}})])])
}]

export { render, staticRenderFns }